import axios from "axios";
import Hotel from "@/Hotels";

const BASE_URL = process.env.NODE_ENV === "development" ? "https://travel.netwiz.ru" : "";

export async function index(city_name: string): Promise<{ hotels: Hotel[], city: {[key:string]: string} }>{

    const params = new URLSearchParams();
    params.append("city",city_name);
    const response = await axios.get(BASE_URL + "/local/components/codeking/tours/hotels/?"+params.toString());
    if(response.status === 200){
        if(response.data.SUCCESS === "Y"){

            const hotels: Hotel[] = [];
            const cities = response.data.DATA.CITY;

            for(const hotel of response.data.DATA.HOTELS){
                const sameHotel = hotels.find(hotel1=>hotel1.name === hotel.NAME);
                if(sameHotel){
                    sameHotel.appendCity(hotel.CITY,cities[hotel.CITY]);
                }else {
                    hotels.push(
                        new Hotel(hotel.NAME,hotel.PICTURE)
                            .setCity(hotel.CITY,cities[hotel.CITY])
                            .setDescription(hotel.DESCRIPTION)
                    )
                }
            }

            return {
                hotels,
                city: response.data.DATA.CITY
            };
        }
        throw new Error(response.data.MESSAGE);
    }
    throw new Error("Ошибка сервера. Повторите попытку позднее");
}